import apiClient from "./client";

export const getAdminSubscribers = async () => {
  const response = await apiClient.get("/subscribe/admin");
  return response.data;
};

export const deleteAdminSubscriber = async ({ id }) => {
  await apiClient.delete(`/subscribe/admin/${id}`);
};
